import { getUrl } from '../../util/api/api'

type fetchJobTokensType = {
  token?: string
  b2bToken?: string
}

const fetchJob = async (id: string, tokens?: fetchJobTokensType) => {
  const { token, b2bToken } = tokens || {}
  const areTokensAvailable = !!(token && b2bToken)
  const fetchResponse = await fetch(
    getUrl(`/dashboard/api/job/get/${id}`),
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        'Content-Type': 'application/json',
        ...(areTokensAvailable ?
          { 'cookie': `__Host-token=${token};__Host-b2b-token=${b2bToken}` }
          :
          {}
        ),
      },
      ...((!areTokensAvailable) ? { credentials: 'include' } : {} ),
      mode: "cors"
    }
  )

  if (fetchResponse?.ok) {
    const responseJson = await fetchResponse.json()
    return Promise.resolve({ status: fetchResponse.status, data: responseJson})
  }

  return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
}

export default fetchJob
